/* Copyright (c) 2017 Backpack Health LLC */

import PropTypes from 'prop-types';

import ColorThemeModel from '../../models/ColorThemeModel';

const ColorTheme = (props) => (
  props.children(ColorThemeModel.getColorTheme(props.colorThemeId, props.colorThemes))
);
ColorTheme.propTypes = {
  children: PropTypes.func,
  colorThemeId: PropTypes.number,
  colorThemes: PropTypes.array,
};

export default ColorTheme;
